module.exports = __webpack_public_path__ + "assets/retina_TParallelDetailed.3a0494a424c7b13f553990efed8ab76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TParallelDetailed.png
// module id = 735
// module chunks = 0